<template>
    <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-card>
          <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
          <ul class="m-list-wrapper">
            <li>
              <a-input-search v-model="search" :disabled="triggerSearch" placeholder="Quick Search" />
            </li>
            <li>
              <a-collapse :activeKey="getScreen ? 0 : 1">
                <a-collapse-panel key="1">
                  <span slot="header">Search More...</span>
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Transaction Date</label>
                    <a-date-picker placeholder="Select Date" v-model="searchDate" :disabled="triggerSearch"
                      :format="getDefaultDateFormat" allowClear />
                  </div>
  
                  <div class="m-form-item-wrapper">
                    <label for="director">Director</label>
                    <a-select placeholder="Choose director" v-model="director" :disabled="triggerSearch" class="width-full"
                      initialValue="undefined" allowClear>
                      <a-select-option v-for="item in listDirector" :key="item.value" :value="item.value">{{ item.text
                      }}</a-select-option>
                    </a-select>
                  </div>
  
                  <div class="m-form-item-wrapper">
                    <label for="tanggalTransaksi">Status</label>
                    <a-select placeholder="Ex: Approved ... " v-model="status" :disabled="triggerSearch" class="width-full"
                      initialValue="delivered" allowClear>
                      <a-select-option v-for="item in getStatus" :key="item.id" :value="item.value">{{ item.label
                      }}</a-select-option>
                    </a-select>
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </li>
          </ul>
        </a-card>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <DataList 
            title="Annual Target List" 
            :isCustom="true"
            :dataList="searching"
            :loading="loading" 
            :price="true"
            createLink="create_klaim_tiket"
            :disabledCreateEditLink="false"
        >
            <template #extra>
                <a-button icon="plus" type="primary" @click="showModalCreate">
                    Create
                </a-button>
            </template>

            <template #content="{ items, paginate }">
                <a-list itemLayout="vertical" :dataSource="items" :pagination="paginate">
                    <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
                    <a-list-item slot="renderItem" slot-scope="item">
                        <a-list-item-meta>
                        <a-row slot="title" type="flex" justify="space-between">
                            <div>
                                <h4 class="margin-remove">{{ item.no_target }}</h4>
                                <small>{{ item.subtitle }}</small>
                            </div>
                            <Status :status="item.active_sts == '1' ? 'Active' : 'Non Active'" :class="getScreen ? 'margin-remove' : 'margin-left'" type="primary"/>
                        </a-row>
                        <div slot="description" class="margin-top">
                            <ul class="m-list-wrapper">
                                <li class="margin-remove">
                                    <span>{{ item.create_dt }} | {{ item.tlc_create }}</span>
                                </li>
                                <li class="margin-remove">
                                    <h4>Overhead : {{ formatCurrency('IDR', item.overhead) }}</h4>
                                </li>
                                <li class="margin-remove">
                                    <h4>Depresiasi : {{ formatCurrency('IDR', item.depresiasi) }}</h4>
                                </li>
                                <li class="margin-remove">
                                    <h4>EBT : {{ formatCurrency('IDR', item.ebt) }}</h4>
                                </li>
                                <li>
                                    <h4>Catatan : {{ item.remark ? item.remark : '-'}}</h4>
                                </li>
                            </ul>
                        </div>
                        </a-list-item-meta>
                        <template #action></template>
                    </a-list-item>
                    </a-list>
            </template>

        </DataList>
      </a-col>

      <a-modal :visible="modal_create" @cancel="modalOnClose" :footer="null" :maskClosable="false" width="50%">
      <span slot="title"> <a-icon type="plus" /> Create Annual Target</span>

      <a-form :form="form_create">
        <a-row :gutter="8">
          <a-col>
            <a-form-item label="Year">
              <a-date-picker v-decorator="['year', { rules: [{ required: true }], initialValue: moment() } ]"
              mode="year"
              format="YYYY"
              placeholder="Select year"
              :open="yearOpen"
              @panelChange="handleYearChange"
              @openChange="handleOpenChange"
              />
            </a-form-item>

            <a-form-item label="Overhead">
              <a-input-number type="number" class="m-width-full m-text-align-right"
              v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
                'overhead',
                { rules: [{ required: true }] },
              ]" />
            </a-form-item>

            <a-form-item label="Depresiasi">
              <a-input-number type="number" class="m-width-full m-text-align-right"
              v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
                'depresiasi',
                { rules: [{ required: true }] },
              ]" />
            </a-form-item>

            <a-form-item label="EBT">
              <a-input-number type="number" class="m-width-full m-text-align-right"
              v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
                'ebt',
                { rules: [{ required: true }] },
              ]" />
            </a-form-item>

            <a-form-item label="Description">
              <a-textarea
              :rows="4"
              v-decorator="['description']"
              allow-clear />
            </a-form-item>
          </a-col>

        </a-row>
        <a-button-group class="width-full">
          <a-button :loading="loading_save" class="margin-top" block type="primary" html-type="submit" ref="savetax" @click="onSubmitCreate"><b>Save</b></a-button>
        </a-button-group>
      </a-form>
    </a-modal>

    </a-row>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import axios from "axios";
import Status from "@/components/Status.vue";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import _ from "lodash";
  
  export default {
    name: "klaimCcTiket",
    props: ["prnMenu"],
    mixins: [CurrencyFormat],
    data() {
      return {
        loading: true,
        dataList: [],
        draftList: [],
        basedList: [],
        listDirector: [],
        searchDate: null,
        search: "",
        status: undefined,
        director: undefined,
        triggerSearch: false,
        modal_create: false,
        loading_save: false,
        yearOpen: false
      };
    },
    computed: {
      ...mapGetters([
        "getScreen",
        "getAuth",
        "getStatus",
        "getDefaultDateFormat",
        "getStandartFormatDate",
      ]),

      searching() {
        var self = this;
        let outputData = this.dataList;
  
        if (this.search) {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          );
        }
  
        if (this.searchDate) {
          let filter = moment(this.searchDate).format(this.getStandartFormatDate);
          outputData = _.filter(outputData, { tgl_buat: filter });
        }
  
        if (this.director) {
          outputData = outputData.filter(
            (obj) =>
              obj.tlc_bod &&
              obj.tlc_bod.toLowerCase().indexOf(self.director.toLowerCase()) >= 0
          );
        }
  
        if (this.status) {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
          );
        }
  
        return outputData;
      },
      getManifestLink() {
        if (localStorage.getItem("nvpn") === "/FinancialControl") {
          return "SpclKlaimCCManifestFin";
        }
      },
    },

    beforeCreate() {
      this.form_create = this.$form.createForm(this);
    },

    created() {
      this.fetchData();
    },
    mounted() {
      Event.$on("callbackTab", this.clickTabed);
    },
    beforeDestroy() {
      Event.$off("callbackTab", this.clickTabed);
    },
    methods: {
      moment,
      async fetchData() {
        try {
            const res = await axios({
                method: "get",
                url: this.$serviceUrl + "annual_target",
                auth: {
                    username: this.getAuth.username,
                    password: this.getAuth.password,
                },
                headers: {
                    "X-API-KEY": this.getAuth.apikey,
                },
            })

            if(res.data.data){
                this.dataList = res.data.data
            }
            this.loading = false
        } catch (error) {
            console.log(error);
            this.loading = false
        }
    },
      clickTabed(val) {
        this.search = "";
        this.searchDate = undefined;
        this.director = undefined;
        this.status = undefined;
        if (val == "draft") {
          this.triggerSearch = true;
        } else {
          this.triggerSearch = false;
        }
      },

      showModalCreate(){
        this.modal_create = true
      },

      modalOnClose(){
        this.modal_create = false
        this.form_create.resetFields()
      },

      onSubmitCreate(){
        this.loading_save = true
        this.form_create.validateFields( async (err, values) => {
          if (err) {
            this.loading_save = false
            this.displayMessage("form-warning");
            return;
          }

          let formData = new FormData()
          formData.append('overhead', values.overhead)
          formData.append('depresiasi', values.depresiasi)
          formData.append('ebt', values.ebt)
          formData.append('remark', values.description)
          formData.append('year',  values.year.format('YYYY'))

          try {
            const res = await axios({
              method: "POST",
              url: this.$serviceUrl + "annual_target",
              auth: {
                  username: this.getAuth.username,
                  password: this.getAuth.password,
              },
              headers: {
                  "X-API-KEY": this.getAuth.apikey,
              },
              data: formData
            })
            this.loading_save = false
            this.modalOnClose()
            this.fetchData()
            this.displayMessage("success-save");
            this.form_create.resetFields()
          } catch (error) {
            this.loading_save = false
            console.log(error);
          }
          
        })
      },

      handleOpenChange(status) {
        this.yearOpen = status
      },

      handleYearChange(value) {
        this.form_create.setFieldsValue({
          year: value
        })

        this.yearOpen = false
      }

    },
  };
  </script>
  
  <style></style>
  